<template>
  <div class="deposit_wrapper">
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
      "
    >
      <h1 class="fat m0_b main_blue_dk_fill" style="font-size: 1.1rem">
        {{ $tc("msg.deposit", 1) }}
      </h1>
    </div>

    <div class="redeem_form">
      <div style="justify-content: center; display: flex">
        <qrcode :value="address" :options="{ width: 200 }"></qrcode>
      </div>

      <div class="tag_container">
        <div
          v-if="!selectedBlue"
          class="balance_tag_reverse tab_black_tron tab_black"
        >
          TRON (TRC20)
        </div>

        <div v-else class="balance_tag_reverse tab_black" style="padding: 0rem 0.7rem;">
          <img src="../../../../assets/images/new-binance-chain-logo.png" />
        </div>
      </div>
    </div>

    <div
      class="pointer"
      v-clipboard:copy="address"
      v-clipboard:success="onCopySuccess"
      v-clipboard:error="onCopyError"
    >
      <div class="button_address_copy">
        <p>
          {{ address }}
        </p>
        <p class="capitalize" style="margin-top: 5px">
          <span v-html="iconSets.copy" class="icon_class_1"></span>
        </p>
      </div>
    </div>

    <div class="column redeem_form">
      <div style="justify-content: center; display: flex; font-size: 0.8rem">
        <router-link to="/transactions/deposits">{{
          $t("msg.view_all_transactions")
        }}</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: ["address", "selectedBlue"],
  created() {
    this.checkAmount();
    this.getWithdrawFee();
  },
  mounted() {},
  data: () => ({
    // address: "bc1qxy2kgdygjrsqtzq2n0yrf2493p83kkfjhx0wlh",
    redeem_error: "",
    bluAmount: 0,
    minBlue: 0,
    maxBluAmount: 99999999999,
    unLockedBalance: "",
    externalId: "",
    feeWithdraw: "",
    validation: {
      amount: false,
      address: false,
    },
    withdraws: "",
    openWithdraws: "",
  }),
  components: {},
  methods: {
    setRedeemError() {
      if (this.bluAmount < this.minBlue) {
        this.redeem_error = "below_min";
      } else {
        this.redeem_error = "no_funds";
      }
    },

    callNextStep() {
      this.$emit("callNext", this.bluAmount);
    },
    switchMode() {
      this.$emit("switchMode");
    },

    async getWithdrawFee() {
      let resp = await this.$store.dispatch("getFees");
      let fees = resp.data;

      let arrayFee = [];

      for (let i in fees) {
        if (fees[i].type == "withdraw") {
          arrayFee.push(fees[i].fee);
        }
      }
      this.feeWithdraw = arrayFee[arrayFee.length - 1];
    },

    xemToBlu(amount) {
      let xemToBlu = amount / this.bluValue[0].value;
      return xemToBlu;
    },

    setMinAmount() {
      let bluValue = this.btcValue[0].value / this.bluValue[0].value;
      this.minBlue = this.bluValue[0].withdrawMinimal;
      this.bluAmount = this.minBlue;
    },

    checkAmount() {
      this.getUnlockedBalance();

      if (this.bluAmount >= 0 && this.bluAmount <= this.unLockedBalance) {
        this.validation.amount = true;
      } else {
        this.validation.amount = false;
      }
    },

    validateAmount() {
      this.bluAmountValid = false;
      let indices = [];
      let amount = String(this.bluAmount);

      var idx = amount.indexOf(".");
      while (idx != -1) {
        indices.push(idx);
        idx = amount.indexOf(".", idx + 1);
      }

      if (indices.length > 1) {
        var n = amount.lastIndexOf(".");
        amount = amount.slice(0, n);
        this.bluAmountValid = false;
      } else {
        this.bluAmountValid = true;
      }

      this.bluAmount = amount;
      this.isNumberCheck();
    },

    isNumberCheck() {
      // let newBluAmount = [];
      // for (let i in this.bluAmount) {
      //   if (
      //     ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "."].includes(
      //       this.bluAmount[i]
      //     )
      //   ) {
      //     newBluAmount.push(this.bluAmount[i]);
      //   }
      // }
      // newBluAmount = newBluAmount.join("");
      // this.bluAmount = newBluAmount;
      // var firstPosition = null;
      // if (newBluAmount.indexOf(".") > 1) {
      //   firstPosition = newBluAmount.indexOf(".");
      // }
      // if (firstPosition) {
      //   let newArray = [];
      //   for (let i in this.bluAmount) {
      //     if (i == firstPosition) {
      //       newArray.push(".");
      //     } else {
      //       if (!isNaN(this.bluAmount[i])) {
      //         newArray.push(this.bluAmount[i]);
      //       }
      //     }
      //   }
      //   newArray = newArray.join("");
      //   this.bluAmount = parseFloat(newArray);
      // }
      // if (this.bluAmount == ".") {
      //   this.bluAmount = "0";
      // }
    },

    getUnlockedBalance() {
      if (this.bluAccount) {
        let totalBalance = this.bluAccount.balance;
        let lockedBalace = this.bluAccount.locked;
        let unLockedBalance = "";

        this.unLockedBalance = totalBalance - lockedBalace;
      }
    },

    validateAdress(address) {
      if (
        (address.length > 10 && address.charAt(0) === "N") ||
        address.charAt(0) === "T"
      ) {
        this.validation.address = false;
      } else {
        this.validation.address = true;
      }
    },

    modifyBluAmount(modifier) {
      if (
        this.bluAmount == false ||
        this.bluAmount < this.minBlue ||
        this.bluAmount == ""
      ) {
        this.bluAmount = this.minBlue;
      } else {
        let vm = this;
        if (modifier == "-" && this.bluAmount > 0) {
          let result = this.bluAmount - 1;
          if (result > this.minBlue) {
            this.bluAmount = vm.roundUp(this.bluAmount - 1, 3);
          } else {
            this.bluAmount = vm.roundUp(vm.minBlue, 3);
          }
        } else if (modifier == "+" && this.bluAmount < this.maxBluAmount) {
          this.bluAmount = parseFloat(this.bluAmount) + 1;
          this.bluAmount = vm.roundUp(this.bluAmount, 3);
        }
      }
    },

    roundUp(num, precision) {
      precision = Math.pow(10, precision);
      return Math.ceil(num * precision) / precision;
    },

    isNumber() {
      let evt = window.event;
      var charCode = evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
  computed: {
    ...mapGetters([
      "btcValue",
      "bluValue",
      "bluAccount",
      "ethValue",
      "xemValue",
    ]),
  },
  watch: {
    withdraws: function () {
      this.checkRunningWithdraws();
    },

    bluAmount: function () {
      this.setRedeemError();
      this.validateAmount();
      this.checkAmount();
    },

    feeWithdraw: function () {
      this.setMinAmount();
    },
  },
};
</script>
<style scoped>
.icon-container {
  background: white;
  width: 70px;
  border-style: solid;
  border-width: 1px 0px 1px 1px;
  border-color: #e3d4d4;
  display: flex;
}
</style>


// WEBPACK FOOTER //
// src/components/private/services/deposit_steps/DepositStep1.vue